import React from 'react'
import './TopNav.scss'
import Link from 'gatsby-link'
import Social from './Social'

class TopNav extends React.Component {
    render(){
        return (
            <nav className="navbar topNav is-fixed-top  is-bold" role="navigation" aria-label="main navigation">
                <div className="navbar-brand">
                    <Link className="title is-4 navbar-item" to="/">
                        @fibasile
                    </Link>
                    <Social></Social>
                </div>
                <div className="navbar-menu">
                    <div className="navbar-end">
                        <div className="navbar-item">
                        <Link to='/'>Blog</Link>
                        </div>
                        <div className="navbar-item">
                        <Link to='/about'>About</Link>
                        </div>
                        <div className="navbar-item">
                        <Link to='/projects'>Projects</Link>
                        </div>
                        <div className="navbar-item">
                        <Link to="/radar">Radar</Link>
                        </div>
                        <div className="navbar-item">
                        <Link to='/contacts'>Contacts</Link>
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
}

export default TopNav



// WEBPACK FOOTER //
// ./src/components/TopNav.js